import { modifier } from 'ember-modifier';

export interface AditoolsRendererSignature {
  Element: HTMLElement;
  Args: {
    Positional: [inserted: (element: HTMLElement) => void, destroying: (element: HTMLElement) => void];
  };
}

export default modifier<AditoolsRendererSignature>((element, [inserted, destroying]) => {
  inserted(element);
  return () => {
    if (destroying) {
      destroying(element);
    }
  };
});
